/**
 * OpenAI Ads Pixel 工具
 *
 * 正式環境：
 * https://dashboard.fotoncard.com
 *
 * Pixel 初始化：
 * public/index.html
 *
 * 目前轉化事件：
 * 1. registration_completed - 註冊成功
 * 2. order_created          - 保證金繳納成功
 */

const PROD_HOST = 'dashboard.fotoncard.com'

/**
 * 判斷是否正式環境
 */
export function isOpenAIProduction() {
  return (
    window.location.protocol === 'https:' &&
    window.location.hostname === PROD_HOST
  )
}

/**
 * 判斷 OpenAI Pixel 是否已初始化
 */
export function isOpenAIPixelReady() {
  return typeof window.oaiq === 'function'
}

/**
 * 發送 OpenAI Pixel measure 事件
 *
 * @param {String} eventName 事件名稱
 * @param {Object} params 事件參數
 * @returns {Boolean}
 */
export function measureOpenAIEvent(eventName, params = {}) {
  // 1. 非正式環境禁止發送
  if (!isOpenAIProduction()) {
    console.log(
      `[OpenAI Pixel] 非正式環境，跳過事件：${eventName}`,
      params
    )

    return false
  }

  // 2. Pixel 未初始化
  if (!isOpenAIPixelReady()) {
    console.warn(
      `[OpenAI Pixel] oaiq 尚未初始化，事件未發送：${eventName}`
    )

    return false
  }

  try {
    // 3. 發送事件
    window.oaiq(
      'measure',
      eventName,
      params
    )

    console.log(
      `[OpenAI Pixel] 事件已發送：${eventName}`,
      params
    )

    return true
  } catch (error) {
    console.error(
      `[OpenAI Pixel] 事件發送失敗：${eventName}`,
      error
    )

    return false
  }
}

/**
 * ========================================
 * 註冊成功
 * ========================================
 *
 * OpenAI Ads 後台事件：
 *
 * oaiq(
 *   "measure",
 *   "registration_completed",
 *   { type: "customer_action" }
 * )
 */
export function trackRegistrationCompleted() {
  return measureOpenAIEvent(
    'registration_completed',
    {
      type: 'customer_action'
    }
  )
}

/**
 * ========================================
 * 保證金繳納成功
 * ========================================
 *
 * OpenAI Ads 後台事件：
 *
 * oaiq(
 *   "measure",
 *   "order_created",
 *   { type: "contents" }
 * )
 */
export function trackGuaranteeDepositCompleted() {
  return measureOpenAIEvent(
    'order_created',
    {
      type: 'contents'
    }
  )
}

export default {
  isProduction: isOpenAIProduction,
  isReady: isOpenAIPixelReady,
  measure: measureOpenAIEvent,
  registrationCompleted: trackRegistrationCompleted,
  guaranteeDepositCompleted: trackGuaranteeDepositCompleted
}